import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpParams } from '@capacitor/core';
import { ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

@Injectable()

export class IacomunicacaoProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  addUpdateAsync(dto: any, isEdit = false): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'iacomunicacao';

      if(isEdit){
        url += `?edit=1`
      }

      me.http.post(url, dto, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  get(tipoComunicacao = null, origem = null, search = null): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = new URL(APIService.API_URL + 'iacomunicacao');

      if(origem)
      {
        url.searchParams.append("origem", origem);
      }

      if(tipoComunicacao)
      {
        url.searchParams.append("tipocomunicacao", tipoComunicacao);
      }

      if(search)
      {
        url.searchParams.append("prompt", search);
      }

      me.http.get(url.toString(), {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  delete(tipoComunicacao, origem): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = new URL(APIService.API_URL + 'iacomunicacao');

      if(origem)
      {
        url.searchParams.append("origem", origem);
      }

      if(tipoComunicacao)
      {
        url.searchParams.append("tipocomunicacao", tipoComunicacao);
      }

      me.http.delete(url.toString(), {headers: this.header}).subscribe((result: any) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        });
    });
  }

  requestAiReview(promptObj: any): Promise<any> {
    var me = this;
    this.header = APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'chatgptapi?operacao=boxai';
      me.http.post(url, promptObj, {headers: this.header}).subscribe((result: any) => {
        resolve(result);
      }, (error) => {
        reject(error);
      });
    });
  }
}
